import * as React from "react";
import { useTranslation } from "react-i18next";
import ResourceContainer from "../../containers/ResourceContainer";

const AdministrationPage = () => {
  const { t } = useTranslation();
  
  return (
    <div>
       <div className="flex items-center px-2 pb-4 border-gray-300">
        <div className="text-2xl font-semibold text-gray-700">{t("administration.label.administration")}</div>
      </div>
      <ResourceContainer></ResourceContainer>
    </div>
  );
};

export default AdministrationPage;
